// datatable related plugins
import Breadcrumbs from "components/Common/Breadcrumb";
import ConfirmModal from "components/shared-components/ConfirmModal";
import CustomDateFilter from "components/shared-components/RemoteTable/custom-date-filter";
import RemoteDataTable from "components/shared-components/RemoteTable/data-table";
import { CUSTOM_DATE_FILTER_TABLE_TYPE } from "constants/RemoteDataTableContanst";
import { formConvertErrorMessage } from "helpers/form_helper";
import React, { useEffect, useState } from "react";
import {
  customFilter,
  selectFilter,
  textFilter,
} from "react-bootstrap-table2-filter";
import { useTranslation } from "react-i18next";
import { MetaTags } from "react-meta-tags";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import { Button, Card, CardBody, Col, Row } from "reactstrap";
import {
  CREATE_SIGN_METHOD_FAIL,
  CREATE_SIGN_METHOD_SUCCESS,
  DELETE_SIGN_METHOD_FAIL,
  DELETE_SIGN_METHOD_SUCCESS,
  EDIT_SIGN_METHOD_FAIL,
  EDIT_SIGN_METHOD_SUCCESS,
} from "store/general-info/sign-method/actionTypes";
import {
  deleteSignMethod,
  getListSignMethod,
  getListVat,
  resetCreateSignMethod,
  resetDeleteSignMethod,
  resetEditSignMethod,
  resetListSignMethod,
  setColumnVisibleSignMethod,
} from "store/general-info/sign-method/actions";
import DetailData from "./DetailData";
import { getStatus } from "./helper/functionHelper";
import { modeDetail } from "./utils";

const ListData = props => {
  const [mode, setMode] = useState(null);
  const [modalDetail, setModalDetail] = useState(false);
  const [dataDetail, setDataDetail] = useState(null);
  const toggleViewDetailModal = () => setModalDetail(!modalDetail);

  const { addToast } = useToasts();

  const [columns, setColumns] = useState([]);

  const dispatch = useDispatch();
  const [idDetail, setIdDetail] = useState(null);
  // Confirm Delete modal
  const [modalConfirmDelete, setModalConfirmDelete] = useState(false);
  const toggleConfirmDeleteModal = () =>
    setModalConfirmDelete(!modalConfirmDelete);
  // store reducer
  const signMethod = useSelector(state => state.signMethod);
  const { loading, listData, totalCount, columnsVisible, params } =
    signMethod.signMethod;
  const history = useHistory();

  const { t, i18n } = useTranslation(["signMethod"]);

  const [commonStatus, setCommonStatus] = useState(getStatus(t));

  useEffect(() => {
    setCommonStatus(getStatus(t));
  }, [t]);

  useEffect(() => {
    initColumn();
  }, [commonStatus]);

  useEffect(() => {
    switch (signMethod.type) {
      case CREATE_SIGN_METHOD_SUCCESS:
        addToast(
          t("message.create", {
            target: t("signMethod"),
            status: t("message.success"),
          }),
          {
            appearance: "success",
            autoDismiss: true,
          }
        );
        toggleViewDetailModal();
        dispatch(getListSignMethod(params));
        dispatch(resetCreateSignMethod());
        break;
      case CREATE_SIGN_METHOD_FAIL:
        if (
          signMethod.createSignMethod.error.code === 422 &&
          signMethod.createSignMethod.error.fields.length > 0
        ) {
          signMethod.createSignMethod.error.fields
            .filter(item => item.field !== "tenant_code")
            .map(item => {
              addToast(
                formConvertErrorMessage(
                  item.message ||
                    t("message.create", {
                      target: t("signMethod"),
                      status: t("message.error"),
                    }),
                  t,
                  t(`form.${item.field}`) + " không hợp lệ."
                ),
                { appearance: "error", autoDismiss: true }
              );
            });
        }
        dispatch(resetCreateSignMethod());
        break;

      case EDIT_SIGN_METHOD_SUCCESS:
        addToast(
          t("message.update", {
            target: t("signMethod"),
            status: t("message.success"),
          }),
          {
            appearance: "success",
            autoDismiss: true,
          }
        );
        toggleViewDetailModal();
        dispatch(getListSignMethod(params));
        dispatch(resetEditSignMethod());
        break;
      case EDIT_SIGN_METHOD_FAIL:
        if (
          signMethod.editSignMethod.error.code === 422 &&
          signMethod.editSignMethod.error.fields.length > 0
        ) {
          signMethod.editSignMethod.error.fields
            .filter(item => item.field !== "tenant_code")
            .map(item => {
              addToast(
                formConvertErrorMessage(
                  item.message ||
                    t("message.update", {
                      target: t("signMethod"),
                      status: t("message.error"),
                    }),
                  t,
                  t(`form.${item.field}`) + " không hợp lệ."
                ),
                { appearance: "error", autoDismiss: true }
              );
            });
        }
        dispatch(resetEditSignMethod());
        break;

      case DELETE_SIGN_METHOD_SUCCESS:
        addToast(
          t("message.delete", {
            target: t("signMethod"),
            status: t("message.success"),
          }),
          {
            appearance: "success",
            autoDismiss: true,
          }
        );
        toggleConfirmDeleteModal();
        dispatch(getListSignMethod(params));
        dispatch(resetDeleteSignMethod());
        break;
      case DELETE_SIGN_METHOD_FAIL:
        addToast(
          t("message.delete", {
            target: t("signMethod"),
            status: t("message.error"),
          }),
          {
            appearance: "error",
            autoDismiss: true,
          }
        );
        dispatch(resetDeleteSignMethod());
        break;
      default:
        break;
    }
  }, [signMethod.type]);

  const Dashboard = useSelector(state => state.Dashboard);
  const { tenantCodeHeader, buStoreHeader } = Dashboard;

  // Action list chang tenantCode
  useEffect(() => {
    if (buStoreHeader) {
      dispatch(getListSignMethod(params));
    }
  }, [buStoreHeader]);

  useEffect(() => {
    if (signMethod.listVat) {
      initColumn();
    }
  }, [signMethod.listVat]);

  useEffect(() => {
    dispatch(getListVat());
    return () => {
      dispatch(resetListSignMethod());
    };
  }, []);

  const initColumn = () => {
    if (Object.keys(columnsVisible).length !== 0) {
      for (const item of initColumns) {
        if (columnsVisible[item.dataField] !== undefined) {
          item.hidden = !columnsVisible[item.dataField];
        }
      }
    }
    setColumns(initColumns);
  };

  const rowEvents = {
    onDoubleClick: (e, row, rowIndex) => {
      setDataDetail(row);
      setMode(modeDetail.VIEW);
      toggleViewDetailModal();
    },
  };

  const listRowAction = [
    {
      icon: <i className="bx bx-edit font-size-18 text-success" />,
      text: "Cập nhật",
      onClick: row => {
        setDataDetail(row);
        setMode(modeDetail.EDIT);
        toggleViewDetailModal();
      },
    },
    {
      icon: <i className="bx bx-trash font-size-18 text-danger" />,
      text: "Xóa",
      onClick: row => {
        setIdDetail(row.id);
        toggleConfirmDeleteModal();
      },
    },
  ];

  const initColumns = [
    {
      dataField: "business_unit_code",
      text: t("form.business_unit_code"),
      sort: true,
    },
    {
      dataField: "company_name",
      text: t("form.company_name"),
      filter: textFilter({
        placeholder: t("placeholder.enter"),
      }),
    },
    {
      dataField: "invoice_type",
      text: t("form.invoice_type"),
      filter: selectFilter({
        placeholder: t("placeholder.select"),
        options: {
          0: "HĐ Không mã",
          1: "HĐ Có mã",
        },
      }),
      formatter: (cellContent, row) => (
        <div style={{ width: "200px", whiteSpace: "initial" }}>
          {cellContent ? "HĐ Có mã" : "HĐ Không mã"}
        </div>
      ),
    },
    {
      dataField: "is_default",
      text: "Sử dụng",
      sort: true,
      formatter: (cell, row) => {
        // "some" return boolean
        return (
          <div className="text-primary fw-bold">
            {Number(cell) === 1 && "Mặc định"}
          </div>
        );
      },
      filter: selectFilter({
        placeholder: t("placeholder.select", {
          title: "Trạng thái sử dụng",
        }),
        options: {
          1: "Mặc định",
        },
      }),
    },
    {
      dataField: "serial_num",
      text: t("form.serial_num"),
      filter: textFilter({
        placeholder: t("placeholder.enter"),
      }),
      // formatter: (cellContent, row) => {
      //   const vat = signMethod.listVat.find(
      //     item => Number(item.id) === Number(cellContent)
      //   );
      //   if (vat) {
      //     return vat.label;
      //   } else if (row.vat_text) {
      //     return row.vat_text;
      //   }
      //   return "Chưa có thuế suất";
      // },
    },
    {
      dataField: "issued_time",
      text: t("form.issued_time"),
      hidden: false,
      // formatter: (cellContent, row) => tableFormateDate(row.checker_date),
      filter: customFilter({
        type: CUSTOM_DATE_FILTER_TABLE_TYPE,
      }),
      filterRenderer: (onFilter, column) => (
        <CustomDateFilter
          onFilter={onFilter}
          column={column}
          paramFilter={params.columnFilter}
        />
      ),
    },
    {
      dataField: "expired_time",
      text: t("form.expired_time"),
      hidden: false,
      // formatter: (cellContent, row) => tableFormateDate(row.checker_date),
      filter: customFilter({
        type: CUSTOM_DATE_FILTER_TABLE_TYPE,
      }),
      filterRenderer: (onFilter, column) => (
        <CustomDateFilter
          onFilter={onFilter}
          column={column}
          paramFilter={params.columnFilter}
        />
      ),
    },
    // {
    //   dataField: "checker_date",
    //   text: "Ngày tạo",
    //   hidden: false,
    //   // formatter: (cellContent, row) => tableFormateDate(row.checker_date),
    //   filter: customFilter({
    //     type: CUSTOM_DATE_FILTER_TABLE_TYPE,
    //   }),
    //   filterRenderer: (onFilter, column) => (
    //     <CustomDateFilter
    //       onFilter={onFilter}
    //       column={column}
    //       paramFilter={params.columnFilter}
    //     />
    //   ),
    // },
  ];

  const handleTableChange = (
    type,
    { page, sizePerPage, sortField, sortOrder, columnFilter }
  ) => {
    params.sort = sortField ? sortOrder + sortField : params.sort;
    params.columnFilter = columnFilter;
    params.page = page;
    params.sizePerPage = sizePerPage;
    dispatch(getListSignMethod(params));
  };

  const onSearchAllHandle = value => {
    params.keywords = value;
    dispatch(getListSignMethod(params));
  };

  const optionShowColumnHandel = (field, value) => {
    const targetColumn = columns.find(item => item.dataField === field);
    if (targetColumn) {
      targetColumn.hidden = !value;
    }
    setColumns(columns);
    dispatch(setColumnVisibleSignMethod(field, value));
  };

  const resetDataFunc = () => {
    dispatch(getListSignMethod(params));
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Danh sách Sign Method</title>
        </MetaTags>
        <div className="container-fluid">
          <Breadcrumbs
            title=""
            breadcrumbItem={"Danh sách Sign Method" + ` (${totalCount})`}
          />
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <React.Fragment>
                    <ConfirmModal
                      isOpen={modalConfirmDelete}
                      titleHeader={"Xác nhận xóa sản phẩm/ dịch vụ"}
                      titleBody={
                        "Hệ thống sẽ thực hiện xóa sản phẩm/ dịch vụ này ?"
                      }
                      isDisableButton={signMethod.deleteSignMethod.loading}
                      onConfirm={note => {
                        dispatch(deleteSignMethod(idDetail));
                      }}
                      textBtnConfirm={"Xác nhận"}
                      textBtnCancel={"Đóng"}
                      toggle={toggleConfirmDeleteModal}
                    />
                    <DetailData
                      dataDetail={dataDetail}
                      listVat={signMethod.listVat}
                      isOpenModal={modalDetail}
                      toggleModal={toggleViewDetailModal}
                      mode={mode}
                    />
                    <RemoteDataTable
                      keyField="id"
                      data={listData}
                      columns={columns}
                      page={params.page}
                      listRowAction={listRowAction}
                      sizePerPage={params.sizePerPage}
                      totalSize={totalCount}
                      loading={loading}
                      onTableChange={handleTableChange}
                      onSearchAllHandle={onSearchAllHandle}
                      optionShowColumnHandel={optionShowColumnHandel}
                      rowEvents={rowEvents}
                    >
                      <Button
                        type="button"
                        color="primary"
                        className="me-2 btn-label"
                        onClick={() => {
                          setDataDetail(null);
                          setMode(modeDetail.CREATE);
                          toggleViewDetailModal();
                        }}
                      >
                        <i className="bx bx-plus label-icon" />
                        Thêm mới
                      </Button>
                    </RemoteDataTable>
                  </React.Fragment>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ListData;
